<script lang="ts">
    import { fly } from 'svelte/transition';
    import { hintStatus } from '@root/src/store';
</script>

<div class="root absolute -top-14 flex w-full items-center justify-center text-center">
    <div
        class="content font-Roboto text-lg font-bold uppercase text-white s-phone:text-2xl desktop:text-4xl"
        in:fly|global={{ y: -10 }}
    >
        {$hintStatus}
    </div>
</div>
